export const MESSAGE_LOG_VIEW_MODAL_ID = 'message-log-view-modal';
